import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'When a customer triggers an AI edit on the platform',
  name: 'asset_edit_generated',
  params: [
    {
      description: 'The asset mode the user switched to',
      name: 'edit_type',
      required: true,
      type: 'enum',
      values: ['removeObject', 'crop', 'orient', 'replaceBackground'],
    },
    {
      description: 'The category of the asset',
      name: 'category',
      required: true,
      type: 'enum',
      values: ['asset_details'],
    },
    {
      description: 'The crop preset used',
      name: 'crop_preset',
      required: false,
      type: 'string',
    },
    {
      description: 'The width of the asset',
      name: 'size_width',
      required: true,
      type: 'number',
    },
    {
      description: 'The height of the asset',
      name: 'size_height',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
